import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#151E1A] py-12">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center">
          <img src="/siq-logo.png" alt="SIQ Adventures" className="h-32 w-auto" />
        </div>
        <p className="text-[#F4EFE6]/45 text-sm text-center">
          Love the Story, Live the Island · Siquijor Island, Philippines
        </p>
        <p className="text-[#F4EFE6]/45 text-sm">
          © {new Date().getFullYear()} SIQ Adventures
        </p>
      </div>
    </footer>
  );
};

export default Footer;
